import './loadingCard.scss';

import { ReactNode } from 'react';

import { LoadingCardProps } from './types/LoadingCardProps';

export const LoadingCard = ({ testId }: LoadingCardProps): ReactNode => {
  return (
    <li className="loading-card" data-testid={testId}>
      <div className="loading-card-image skeleton-loading-sweep" />
      <div className="loading-card-content">
        <div className="loading-card-line skeleton-loading-sweep" />
        <div className="loading-card-line loading-card-line-short skeleton-loading-sweep" />
      </div>
    </li>
  );
};
